import { render, staticRenderFns } from "./XueYaChart.vue?vue&type=template&id=28324168&scoped=true&"
import script from "./XueYaChart.vue?vue&type=script&lang=js&"
export * from "./XueYaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28324168",
  null
  
)

export default component.exports